import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { CallflowsPageResponse } from 'types/callflow';
import { UsersPageResponse } from 'types/user/UsersPageResponse';
import userQueryKeys from './userQueryKeys';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  mask?: any;
  quick?: boolean;
  options?: Omit<
    UseQueryOptions<UsersPageResponse, Error, UsersPageResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >;
}

export const useListUsersQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['lastName', 'asc']],
  filters = {},
  mask = '*',
  quick = false,
  options,
}: QueryParams) => {
  // returns list of users
  // - just get ALL users+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = quick
    ? userQueryKeys.listQuick(skip, take, orderBy, filters, mask)
    : userQueryKeys.list(skip, take, orderBy, filters, mask);

  const func = quick ? 'usersQuick' : 'users';
  const query = useQuery<UsersPageResponse, Error>(
    queryKey,
    () =>
      sdk.user.query[func](
        {
          skip,
          take,
          orderBy,
          filters,
          mask,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      ...options,
      keepPreviousData: options?.keepPreviousData ?? true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListUsersQuery;
